import { CPF } from "cpf_cnpj";

const cpf = (value) => {
  return value ? CPF.isValid(value) : true;
};

export default cpf;
